import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client'

import { authLink, reportHttpLink, responseTimeLink } from '@/lib/apollo/links'

const client = new ApolloClient({
  link: ApolloLink.from([responseTimeLink, authLink, reportHttpLink]),
  cache: new InMemoryCache(),
})

export default client
